<template>
  <div>
    <div class="NativePage">
      <div class="topSearch">
        <form action="/">
          <van-search
            v-model="search.key"
            placeholder="请输入搜索关键词"
            show-action
            background="#201B19"
            @search="onSearch"
            @cancel="onCancel"
          >
            <div slot="action" class="changeButton"><span @click="gotoShop">店铺</span> | <span @click="gotoCenter">全球</span> </div>
          </van-search>
        </form>
      </div>
      <div class="serType">
        <van-dropdown-menu class="serTypeBar" active-color="#E32119">
          <van-dropdown-item v-model="search.sort" :options="optionSort" @change="selectTypeClose" />
          <van-dropdown-item v-model="search.course" :options="optionCourse" @change="selectTypeClose" />
          <van-dropdown-item v-model="search.divecenter" :options="optionDiveCenter" @change="selectTypeClose" />
        </van-dropdown-menu>
      </div>
    </div>
    <div class="listBody">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了，可以改变搜索条件查看更多！"
        @load="onLoad"
      >
        <div v-for="item in list" :key="item.id" class="commodity">
          <van-row>
            <van-col span="7"><img class="icon" :src="item.icon" @click="inCommodity(item.id)"></van-col>
            <van-col span="1" />
            <van-col span="16">
              <span class="pageTitle1 title" @click="inCommodity(item.id)">{{ item.title }}</span><br>
              <div class="downRect1" @click="inCommodity(item.id)"><span class="price">￥{{ item.lowPrice }}</span><span class="pagebody2 aboutStr">月售{{ item.sellNum }} | 评价{{ item.commentNum }}</span></div>
              <div class="downRect"><span class="pagebody2 aboutStr">{{ item.shopName }}</span><span class="pagebody2" @click="inShop(item.shopId)">&nbsp;&nbsp;进店>></span></div>
            </van-col>
          </van-row>
        </div>
      </van-list>
      <div class="downHideLine" />
    </div>
    <NativeBar select="store" />
  </div>
</template>
<script>
import request from '@/utils/request'
import { Search, DropdownMenu, DropdownItem, List } from 'vant'
import NativeBar from '@/components/NativeBar'
import { initPage, getUrlKey } from '@/utils/base'
export default {
  components: {
    [Search.name]: Search,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [List.name]: List,
    NativeBar
  },
  data() {
    return {
      loading: false,
      finished: false,
      offsetTop: 0,
      list: [],
      saveCourseId: undefined,
      search: {
        key: undefined,
        sort: 'BASE',
        course: '',
        divecenter: 'MYDC',
        limit: 30,
        page: 1,
        courseId: undefined
      },
      optionSort: [
        { text: '推荐排序', value: 'BASE' },
        { text: '价格最低', value: 'LOW' },
        { text: '价格最高', value: 'HIGH' },
        { text: '销量最高', value: 'SELL' },
        { text: '好评最多', value: 'COMMENT' }
      ],
      optionCourse: [
        { text: '全部课程', value: '' },
        { text: '水肺课程', value: 'Diving Program' },
        { text: '自由潜课程', value: 'Freediving Program' }
      ],
      optionDiveCenter: [
        { text: '全部中心', value: 'ALL' },
        { text: '我的中心', value: 'MYDC' }
      ]
    }
  },
  created() {
    initPage(false)
  },
  activated() {
    initPage(false)
    // keep-alive组件 页面进入的时候设置滚动高度
    document.documentElement.scrollTop = this.offsetTop
    console.log('activated', this.offsetTop)

    var courseId = getUrlKey('courseId')
    if (courseId !== null) {
      this.search.courseId = courseId
    } else {
      this.search.courseId = undefined
    }
    var serKey = getUrlKey('serKey')
    if (this.search.courseId !== this.saveCourseId || serKey !== null) {
      if (this.search.courseId !== this.saveCourseId) {
        this.saveCourseId = this.search.courseId
      }
      if (serKey !== null) {
        if (serKey === 'null') {
          serKey = ''
        }
        this.search.key = serKey
      }
    }
    this.list = []
    this.search.page = 1
    this.finished = false
    this.onLoad()
  },
  beforeRouteLeave(to, from, next) {
    // keep-alive 组件停用时调用（简单理解为组件离开的时候）。
    // 获取页面滚动高度，这个钩子有可能会拿不到数据，因为这个钩子执行的慢，可以用beforeRouteLeave代替
    console.log('beforeRouteLeave', this.offsetTop)
    this.offsetTop = document.documentElement.scrollTop
    next()
  },
  methods: {
    selectTypeClose() {
      this.list = []
      this.search.page = 1
      this.finished = false
      this.onLoad()
    },
    onSearch() {
      this.list = []
      this.search.page = 1
      this.finished = false
      this.onLoad()
    },
    onCancel() {
      this.search.key = ''
      this.list = []
      this.search.page = 1
      this.finished = false
      this.onLoad()
    },
    gotoShop() {
      this.$router.replace('/store/diveshopList')
    },
    gotoCenter() {
      this.$router.replace('/store/globaldivecenterList')
    },
    inShop(id) {
      this.$router.replace('/store/commodityList/' + id)
    },
    inCommodity(id) {
      this.$router.replace('/store/commodity/' + id)
    },
    onLoad() {
      if (this.loading) {
        return
      }
      this.loading = true
      request({
        url: '/Store/getShopCommodityList',
        method: 'post',
        data: this.search
      }).then(response => {
        if (!response.success) {
          this.error = true
          return
        }
        this.loading = false
        this.search.limit = response.data.limit
        this.search.page = response.data.page + 1
        response.data.rows.forEach(item => {
          this.list.push(item)
        })
        if (response.data.rows.length < this.search.limit) {
          this.finished = true
        }
      })
    }

  }
}
</script>
<style scoped>
.topSearch{
  padding: 1em 0  1.5em 0;
  background-color: #201B19;
  position: fixed;
  left: 0;
  width: 100%;
  top:0;
   z-index: 10;
}
.topSearch .changeButton{
  color: #fff;
}
.serType{
    background-color: #fff;
    position: fixed;
    left: 0;
    top:5em;
    height: 3em;
    width: 100%;
    z-index: 10;
    border-top-left-radius: 1em;
    border-top-right-radius: 1em;
}
.serType .serTypeBar{
  width: calc(100% - 2em);
  left: 1em;
}
.listBody{
  margin-top: 6em;
  padding: 0 1em;
}
.downHideLine{
  height: 3em;
}
.commodity{
     border-bottom: 1px solid #dadada;
    margin: 1em 0;
    padding-bottom: 1em;
    position: relative;
}
.commodity .icon{
    width: 100%;
}
.commodity .downRect{
    position: absolute;
    bottom: 1.2em;
    left: 33%;
    right: 0;
}
.commodity .downRect1{
    position: absolute;
    bottom: 2.7em;
    left: 33%;
    right: 0;
}
.commodity .downRect1 .price{
    color:#E32119;
    font-weight: 700;
    margin-right: 1.5em;
}
.commodity .title{
    overflow: hidden;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
}

</style>
